import { render, staticRenderFns } from "./addEditMappingModal.vue?vue&type=template&id=1fa15cf2&scoped=true&"
import script from "./addEditMappingModal.vue?vue&type=script&lang=ts&"
export * from "./addEditMappingModal.vue?vue&type=script&lang=ts&"
import style0 from "./addEditMappingModal.vue?vue&type=style&index=0&id=1fa15cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa15cf2",
  null
  
)

export default component.exports